/* eslint-disable @typescript-eslint/naming-convention */
import type { TextElement } from '@studiobuki/web-core/lib/book-common';
import {
  APJapanesefont_000000_16,
  APJapanesefont_000000_20,
  APJapanesefont_000000_24,
  KaiseiOpti_000000_30,
  KozGoProBold_0b4561_30,
  KozGoProBold_0b4561_31,
  Wahupop_000000_24,
} from './_styles';

const SEGMENT_0_text_value_1 = 'ゆめの{{heroName}}{{kidstitle}}せん';

export const SEGMENT_0_text_1: TextElement = {
  align: 'center',
  style: KozGoProBold_0b4561_31,
  text: SEGMENT_0_text_value_1,
  textPath: 'M 0 0 S 421 -280 842 0',

  x: 0,
  y: 230,
};
const SEGMENT_0_text_value_2 = '{{genderIndex}}のでんしゃ';

export const SEGMENT_0_text_2: TextElement = {
  align: 'center',
  style: KozGoProBold_0b4561_30,
  text: SEGMENT_0_text_value_2,
  textPath: 'M 0 0 S 421 -280 842 0',

  x: 0,
  y: 175,
};

const SEGMENT_1_text_value_1 =
  'でんしゃは　いろんなばしょに　つれていってくれるね\n' +
  'じんせいも　でんしゃみたいだよ。\n' +
  'ときには　とっきゅうみたいに　はやくすすんだり\n' +
  'ときには　かくえきていしゃみたいに\n' +
  'ゆっくりけしきを　たのしんだり。\n' +
  'どんなみちを　えらんでも\n' +
  '{{heroName}}{{kidstitle}}の　だいすきなことを　たいせつにしてね。';

export const SEGMENT_1_text_1: TextElement = {
  align: 'center',
  style: APJapanesefont_000000_16,
  text: SEGMENT_1_text_value_1,
  x: 388,
  y: 164,
  width: 400,
  rotation: 3,
};

const SEGMENT_2_text_value_1 = 'いまの　{{heroName}}{{kidstitle}}には、';

export const SEGMENT_2_text_1: TextElement = {
  align: 'center',
  style: APJapanesefont_000000_20,
  text: SEGMENT_2_text_value_1,
  x: 20,
  y: 355,
  width: 300,
};

// const SEGMENT_4_text_value_1 = '{{heroName}}{{kidstitle}}のでんしゃが';
//
// export const SEGMENT_4_text_1: TextElement = {
//   align: 'center',
//   style: APJapanesefont_000000_20,
//   text: SEGMENT_4_text_value_1,
//   x: 62,
//   y: 208,
//   width: 230,
//   rotation: -30,
// };

const SEGMENT_5_text_value_1 = '{{heroName}}{{kidstitle}}のでんしゃが';

export const SEGMENT_5_text_1: TextElement = {
  align: 'center',
  style: APJapanesefont_000000_24,
  text: SEGMENT_5_text_value_1,
  x: 35,
  y: 92,
  width: 400,
};

const SEGMENT_5_text_value_2 = 'このでんしゃはね、{{heroName}}{{kidstitle}}の';

export const SEGMENT_5_text_2: TextElement = {
  align: 'center',
  style: APJapanesefont_000000_24,
  text: SEGMENT_5_text_value_2,
  x: 410,
  y: 308,
  width: 400,
};

const SEGMENT_5_text_value_3 =
  '{{heroName}}{{kidstitle}}のでんしゃが　えきにむかって　はしります。';

export const SEGMENT_5_text_3: TextElement = {
  align: 'center',
  style: APJapanesefont_000000_24,
  text: SEGMENT_5_text_value_3,
  x: 365,
  y: 458,
  width: 360,
};

const SEGMENT_11_text_value_1 = 'と、{{heroName}}{{kidstitle}}。';

export const SEGMENT_11_text_1: TextElement = {
  align: 'left',
  style: APJapanesefont_000000_20,
  text: SEGMENT_11_text_value_1,
  x: 132,
  y: 55,
  width: 200,
};

const SEGMENT_15_text_value_1 =
  '{{heroName}}{{kidstitle}}は　こえを　かけました。';

export const SEGMENT_15_text_1: TextElement = {
  align: 'left',
  style: APJapanesefont_000000_20,
  text: SEGMENT_15_text_value_1,
  x: 453,
  y: 498,
  width: 300,
};

const SEGMENT_17_text_value_1 = '「ありがとう！　{{heroName}}{{kidstitle}}！」';

export const SEGMENT_17_text_1: TextElement = {
  align: 'center',
  style: APJapanesefont_000000_20,
  text: SEGMENT_17_text_value_1,
  x: 430,
  y: 150,
  width: 300,
};

const SEGMENT_21_text_value_1 =
  'あるから、いってみよう。」と、{{heroName}}{{kidstitle}}。';

export const SEGMENT_21_text_1: TextElement = {
  align: 'center',
  style: APJapanesefont_000000_20,
  text: SEGMENT_21_text_value_1,
  x: 425,
  y: 550,
  width: 340,
};

const SEGMENT_23_text_value_1 = 'と、{{heroName}}{{kidstitle}}。';

export const SEGMENT_23_text_1: TextElement = {
  align: 'left',
  style: APJapanesefont_000000_20,
  text: SEGMENT_23_text_value_1,
  x: 627,
  y: 34,
  width: 200,
};

const SEGMENT_24_text_value_1 = '「{{heroName}}{{kidstitle}}、たいへんだ！';

export const SEGMENT_24_text_1: TextElement = {
  align: 'center',
  style: APJapanesefont_000000_20,
  text: SEGMENT_24_text_value_1,
  x: 300,
  y: 71,
  width: 400,
};

const SEGMENT_25_text_value_1 = '{{heroName}}{{kidstitle}}が　たったひとりで、';

export const SEGMENT_25_text_1: TextElement = {
  align: 'center',
  style: APJapanesefont_000000_20,
  text: SEGMENT_25_text_value_1,
  x: 428,
  y: 508,
  width: 300,
};

const SEGMENT_27_text_value_1 =
  '「りょうかいしました、{{heroName}}{{kidstitle}}。すぐに　ぎじゅつしゃが　かけつけます！」';

export const SEGMENT_27_text_1: TextElement = {
  align: 'center',
  style: APJapanesefont_000000_20,
  text: SEGMENT_27_text_value_1,
  x: 133,
  y: 80,
  width: 600,
};
export const SEGMENT_30_text_value_1 =
  'こうして[ゆめのでんしゃ、{{heroName}}ごう]は';

export const SEGMENT_30_text_1: TextElement = {
  align: 'center',
  style: APJapanesefont_000000_20,
  text: SEGMENT_30_text_value_1,
  x: 183,
  y: 439,
  width: 600,
};

const SEGMENT_32_text_value_1 =
  '「あら、{{heroName}}{{kidstitle}}。おもちゃで　あそんでたの？」\n「うん！　そうなんだ！　すきなものをつなげて　でんしゃにしたんだ」\n「わぁ、ステキ！　{{heroName}}{{kidstitle}}は　ほんとうに';

export const SEGMENT_32_text_1: TextElement = {
  align: 'center',
  style: APJapanesefont_000000_20,
  text: SEGMENT_32_text_value_1,
  x: 92,
  y: 159,
  width: 490,
};

const SEGMENT_32_text_value_2 =
  '{{1st like}}と {{2nd like}}と {{3rd like}}が だいすきだね。';

export const SEGMENT_32_text_2: TextElement = {
  align: 'center',
  style: Wahupop_000000_24,
  text: SEGMENT_32_text_value_2,
  x: 47,
  y: 227,
  width: 600,
};

const SEGMENT_32_text_value_3 =
  'だいすきなものが　いっぱいある　{{heroName}}{{kidstitle}}は　すてきだよ」';

export const SEGMENT_32_text_3: TextElement = {
  align: 'center',
  style: APJapanesefont_000000_20,
  text: SEGMENT_32_text_value_3,
  x: 92,
  y: 258,
  width: 490,
};

export const SEGMENT_34_text_value_1 =
  '{{heroName}}{{kidstitle}}の　ゆめの　ろせんず';

export const SEGMENT_34_text_1: TextElement = {
  align: 'center',
  style: KaiseiOpti_000000_30,
  text: SEGMENT_34_text_value_1,
  x: 128,
  y: 61,
  width: 550,
};

const SEGMENT_99030_text_value_1 =
  '{{stationOrderFinal}}　やってきたのは　むしのもりえき　です!\nここには　{{heroName}}{{kidstitle}}のだいすきな';

export const SEGMENT_99030_text_1: TextElement = {
  align: 'center',
  style: APJapanesefont_000000_20,
  text: SEGMENT_99030_text_value_1,
  x: 154,
  y: 28,
  width: 480,
};

const SEGMENT_99031_text_value_1 =
  '{{stationOrder}}　やってきたのは　きょうりゅうえき　です!\nわぁ！　{{heroName}}{{kidstitle}}の　だいすきな';

export const SEGMENT_99031_text_1: TextElement = {
  align: 'center',
  style: APJapanesefont_000000_20,
  text: SEGMENT_99031_text_value_1,
  x: 111,
  y: 445,
  width: 480,
};

const SEGMENT_99032_text_value_1 =
  '{{stationOrder}}　たべものえきに　とうちゃく！\nここは　{{heroName}}{{kidstitle}}の　だいすきな　たべもので　あふれてる！';

export const SEGMENT_99032_text_1: TextElement = {
  align: 'center',
  style: APJapanesefont_000000_20,
  text: SEGMENT_99032_text_value_1,
  x: 85,
  y: 460,
  width: 460,
};

const SEGMENT_99033_text_value_1 =
  '{{stationOrder}}　プリンセスえきに　とうちゃく！';

export const SEGMENT_99033_text_1: TextElement = {
  align: 'center',
  style: APJapanesefont_000000_20,
  text: SEGMENT_99033_text_value_1,
  x: 0,
  y: 145,
  width: 460,
};

const SEGMENT_99034_text_value_1 =
  '{{stationOrder}}　どうぶつえきに　つきました！\n' +
  'ここは　どうぶつたちの　パラダイス！\n' +
  'うみもあれば、かわもある。もりもあれば　サバンナもある。\n' +
  '{{heroName}}{{kidstitle}}の　すきな　ばしょは　どこかな？';

export const SEGMENT_99034_text_1: TextElement = {
  align: 'left',
  style: APJapanesefont_000000_20,
  text: SEGMENT_99034_text_value_1,
  x: 89,
  y: 30,
  width: 600,
};

const SEGMENT_99035_text_value_1 =
  '{{stationOrderFinal}}　こうさくえきに\nとうちゃくしました。';

export const SEGMENT_99035_text_1: TextElement = {
  align: 'center',
  style: APJapanesefont_000000_20,
  text: SEGMENT_99035_text_value_1,
  x: 250,
  y: 330,
  width: 600,
};

const SEGMENT_99035_text_value_2 =
  'ここでは、みんなクリエイター！　{{heroName}}{{kidstitle}}も　そうだよね？\nぜひ　{{heroName}}{{kidstitle}}にしか　つくれないものを、つくっていって。';

export const SEGMENT_99035_text_2: TextElement = {
  align: 'center',
  style: APJapanesefont_000000_20,
  text: SEGMENT_99035_text_value_2,
  x: -43,
  y: 511,
  width: 600,
};

const SEGMENT_99037_text_value_1 =
  '{{heroName}}{{kidstitle}}、よかったら、てつだってくれる？';

export const SEGMENT_99037_text_1: TextElement = {
  align: 'center',
  style: APJapanesefont_000000_20,
  text: SEGMENT_99037_text_value_1,
  x: 217,
  y: 68,
  width: 500,
};

const SEGMENT_99038_text_value_1 =
  '{{heroName}}{{kidstitle}}、いっしょに　さがしてくれるかな？';

export const SEGMENT_99038_text_1: TextElement = {
  align: 'center',
  style: APJapanesefont_000000_20,
  text: SEGMENT_99038_text_value_1,
  x: 126,
  y: 158,
  width: 500,
};

const SEGMENT_99042_text_value_1 =
  'ほんとうに　{{heroName}}{{kidstitle}}は　むしのもりのことを　しってるね。';

export const SEGMENT_99042_text_1: TextElement = {
  align: 'center',
  style: APJapanesefont_000000_20,
  text: SEGMENT_99042_text_value_1,
  x: 146,
  y: 446,
  width: 490,
};

const SEGMENT_99042_text_value_2 =
  '{{heroName}}{{kidstitle}}　だいすきになってくれて　ありがとう。';

export const SEGMENT_99042_text_2: TextElement = {
  align: 'center',
  style: APJapanesefont_000000_20,
  text: SEGMENT_99042_text_value_2,
  x: 163,
  y: 500,
  width: 460,
};

const SEGMENT_99043_text_value_1 =
  '{{heroName}}{{kidstitle}}、さがしものを　てつだってくれてありがとう！\nほんとうに　{{heroName}}{{kidstitle}}は　ものしりだね。\nおれいに　スフィンクスの　おまもりを　プレゼント。';

export const SEGMENT_99043_text_1: TextElement = {
  align: 'center',
  style: APJapanesefont_000000_20,
  text: SEGMENT_99043_text_value_1,
  x: 40,
  y: 33,
  width: 460,
};

const SEGMENT_99043_text_value_2 =
  '{{heroName}}{{kidstitle}}　きょうりゅうや　こだいのなぞを\nだいすきでいてくれて　ありがとう。';

export const SEGMENT_99043_text_2: TextElement = {
  align: 'center',
  style: APJapanesefont_000000_20,
  text: SEGMENT_99043_text_value_2,
  x: 450,
  y: 515,
  width: 340,
};

const SEGMENT_99044_text_value_1 =
  '{{heroName}}{{kidstitle}}、みんなを　みつけてくれてありがとう！ \nよかったら　このキーホルダーを　もっていって。\n{{heroName}}{{kidstitle}}、たべものを　だいすきでいてくれて　ありがとう。';

export const SEGMENT_99044_text_1: TextElement = {
  align: 'center',
  style: APJapanesefont_000000_20,
  text: SEGMENT_99044_text_value_1,
  x: 81,
  y: 40,
  width: 410,
};

const SEGMENT_99045_text_value_1 = '{{heroName}}{{kidstitle}}、';

export const SEGMENT_99045_text_1: TextElement = {
  align: 'left',
  style: APJapanesefont_000000_20,
  text: SEGMENT_99045_text_value_1,
  x: 44,
  y: 66,
  width: 200,
};

const SEGMENT_99045_text_value_2 =
  '{{heroName}}{{kidstitle}}　わたしたちを　すきになってくれて　ありがとう。\nわたしたちも　{{heroName}}{{kidstitle}}のことが、だいすきだよ。';

export const SEGMENT_99045_text_2: TextElement = {
  align: 'center',
  style: APJapanesefont_000000_20,
  text: SEGMENT_99045_text_value_2,
  x: 212,
  y: 511,
  width: 500,
};

const SEGMENT_99046_text_value_1 = '{{heroName}}{{kidstitle}}、';

export const SEGMENT_99046_text_1: TextElement = {
  align: 'center',
  style: APJapanesefont_000000_20,
  text: SEGMENT_99046_text_value_1,
  x: 17,
  y: 69,
  width: 280,
};

const SEGMENT_99046_text_value_2 =
  '{{heroName}}{{kidstitle}}、　ぼくたちのことを　すきでいてくれて、ありがとう。';

export const SEGMENT_99046_text_2: TextElement = {
  align: 'center',
  style: APJapanesefont_000000_20,
  text: SEGMENT_99046_text_value_2,
  x: 193,
  y: 485,
  width: 550,
};

const SEGMENT_99047_text_value_1 =
  '{{heroName}}{{kidstitle}}、みつけてくれて　ありがとう！';

export const SEGMENT_99047_text_1: TextElement = {
  align: 'left',
  style: APJapanesefont_000000_20,
  text: SEGMENT_99047_text_value_1,
  x: 35,
  y: 39,
  width: 500,
};
const SEGMENT_99047_text_value_2 =
  '{{heroName}}{{kidstitle}}、つくりたいものがあるって　すてきだね。';

export const SEGMENT_99047_text_2: TextElement = {
  align: 'left',
  style: APJapanesefont_000000_20,
  text: SEGMENT_99047_text_value_2,
  x: 62,
  y: 488,
  width: 500,
};
